import { ComponentProps, forwardRef } from 'react'

import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { styled } from '@mui/material'
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers'

import { Icon } from '../Icon/Icon'
import { IconButton } from '../IconButton/IconButton'
import { TextField } from '../TextField/TextField'

export type TimePickerProps = Omit<ComponentProps<typeof StyledTimePicker>, 'variant' | 'round' | 'ampm' | '$round'> & {
  round?: boolean
}

export const TimePicker = forwardRef<HTMLInputElement, TimePickerProps>(({ round, ...props }, ref) => (
  <StyledTimePicker
    inputRef={ref}
    $round={round}
    ampm={false}
    slots={{
      textField: TextField,
      openPickerButton: IconButton,
      openPickerIcon: () => (
        <StyledIcon icon={faClock}></StyledIcon>
      ),
    }}
    {...props}
  />
))


const StyledTimePicker = styled(MuiTimePicker, {
  shouldForwardProp: (prop) => prop !== '$round',
}) <{ $round: boolean | undefined }>`
  width: 100%;
`

const StyledIcon = styled(Icon)`
  font-size: ${props => props.theme.typography.pxToRem(16)};
  width: ${props => props.theme.typography.pxToRem(16)};
  height: ${props => props.theme.typography.pxToRem(16)};
  color: ${props => props.theme.palette.text.secondary};
`